<template>
  <div class="md-layout">
    <md-toolbar
      id="booking_profile_header"
      md-elevation="0"
      class="md-transparent"
    >
      <div class="md-toolbar-row" v-if="booking">
        <div class="md-toolbar-section-start">
          <div>
            <div class="md-headline">
              <router-link
                :to="{
                  name: 'Customer Profile',
                  params: { id: booking.lead_booker.id }
                }"
                >{{ booking.lead_booker.first_name }}
                {{ booking.lead_booker.last_name }}</router-link
              >
            </div>
            <div class="md-body-1">
              <span v-show="booking.lead_booker.email"
                ><md-icon class="md-primary">alternate_email</md-icon>
                <a :href="`mailto:${booking.lead_booker.email}`">
                  {{ booking.lead_booker.email }}</a
                ></span
              >
              <span v-show="booking.lead_booker.tel_num"
                ><md-icon class="md-primary">phone</md-icon>
                {{ booking.lead_booker.tel_num }}</span
              >
              <span v-show="booking.lead_booker.cell_num"
                ><md-icon class="md-primary">phone_iphone</md-icon>
                {{ booking.lead_booker.cell_num }}</span
              >
            </div>
          </div>
        </div>
        <div class="md-toolbar-section-end">
          <div class="cancel-booking">
            <md-field>
              <label for="cancelBooking">Cancel Booking ...</label>
              <md-select
                v-model="cancelData"
                name="cancelBooking"
                id="cancelBooking"
              >
                <md-option
                  v-for="option in cancelOptions"
                  :key="option.id"
                  :value="option.value"
                >
                  {{ option.description }}
                </md-option>
              </md-select>
            </md-field>
            <md-button
              class="md-icon-button md-dense md-danger md-round cancel-booking-btn"
              @click="cancelBooking"
            >
              <md-icon>privacy_tip</md-icon>
              <md-tooltip md-direction="top">Cancel this Booking</md-tooltip>
            </md-button>
          </div>
          <manager-dropdown
            v-model="booking.manager.id"
            @input="managerSelected"
          />
        </div>
      </div>
    </md-toolbar>

    <div class="md-layout-item md-size-60" v-if="booking">
      <booking-summary
        :booking="booking"
        style="margin-bottom:3em;"
        @bookingChanged="bookingChanged"
      ></booking-summary>
      <booking-tour-group
        :booking="booking"
        @travellerAdded="travellerAdded"
        @travellerRemoved="travellerRemoved"
        @bookingChanged="bookingChanged"
      ></booking-tour-group>
    </div>
    <div class="md-layout-item md-size-40" v-if="booking">
      <booking-tabs
        v-if="financials"
        :booking="booking"
        :financials="financials"
        @bookingChanged="bookingChanged"
        @transactionAdded="transactionAdded"
      ></booking-tabs>
    </div>
  </div>
</template>

<script>
import BookingSummary from "./BookingSummary.vue";
import BookingTourGroup from "./BookingTourGroup.vue";
import BookingTabs from "./BookingTabs.vue";
import ManagerDropdown from "@/components/Handi/Users/ManagerDropdown.vue";

import bookingApi from "@/services/api/booking";

import _filter from "lodash/filter";
import _remove from "lodash/remove";

export default {
  props: ["id"],

  data() {
    return {
      booking: null,
      financials: null,
      cancelData: null,
      cancelOptions: [
        { id: 1, description: "Cancel", value: "cancelled" },
        {
          id: 2,
          description: "Cancel with Credit",
          value: "cancelled_credit"
        }
      ]
    };
  },

  components: {
    BookingSummary,
    BookingTabs,
    BookingTourGroup,
    ManagerDropdown
  },

  methods: {
    getBooking(id) {
      bookingApi.getBooking(id).then(response => {
        this.booking = response.data;
        this.getFinancials(this.booking);
      });
    },

    cancelBooking() {
      if (!this.cancelData) return;

      let data = {
        booking: this.booking,
        withCredit: this.cancelData == "cancelled_credit"
      };

      bookingApi.cancelBooking(data).then(response => {
        this.getFinancials(this.booking);

        this.booking.status = response.data.booking.status;
      });
    },

    travellerAdded(traveller) {
      this.booking.travellers.push(traveller);

      this.bookingChanged(this.booking);

      this.$notify({
        timeout: 2500,
        message: "New Traveller Added.",
        icon: "thumb_up",
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "success"
      });
    },

    travellerRemoved(traveller) {
      this.booking.travellers = _filter(this.booking.travellers, function(el) {
        return el.id !== traveller.id;
      });

      this.bookingChanged(this.booking);

      this.$notify({
        timeout: 2500,
        message: "Traveller Removed.",
        icon: "thumb_up",
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "warning"
      });
    },

    extraAdded(data) {
      data.traveller.push(data.extra);

      this.bookingChanged(this.booking);

      this.$notify({
        timeout: 2500,
        message: "New Extra Added.",
        icon: "thumb_up",
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "success"
      });
    },

    bookingChanged(booking) {
      this.getFinancials(booking);
    },

    departureChanged(booking) {},

    transactionAdded(transaction) {
      this.booking.transactions.push(transaction);
      this.bookingChanged(this.booking);
    },

    getFinancials(booking) {
      bookingApi.getFinancials(booking.id).then(response => {
        this.financials = response.data;
      });
    },

    managerSelected(managerId) {
      bookingApi
        .updateBooking({
          setmanager: true,
          id: this.booking.id,
          manager: {
            id: managerId
          }
        })
        .then(response => {
          this.$notify({
            timeout: 2500,
            message: "The Manager has been assigned.",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        })
        .catch(error => {});
    }
  },

  computed: {
    allowCancel() {
      let allow =
        this.booking.status.value != "cancelled" &&
        this.booking.status.value != "cancelled_credit";
      return allow;
    }
  },

  watch: {
    "$route.params.id": function(id) {
      this.getBooking(id);
    }
  },

  mounted() {
    this.getBooking(this.id);
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

#booking_profile_header {
  margin-bottom: 1rem;

  .md-headline {
    margin-bottom: 0.5rem;
  }

  span {
    display: inline-block;
    margin-right: 1rem;
  }

  .md-toolbar-section-end {
    align-self: flex-end;
  }

  .cancel-booking-btn {
    margin-right: 0px;
  }

  .cancel-booking {
    border-radius: 5px;
    padding: 3px 7px 5px 7px;
    margin-right: 1em;
    border: 2px solid $red-900;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #b71c1c1f;
  }
}
</style>
